export default __webpack_public_path__ + "static/media/bekota.5cb3a977.png";